import { ColumnEditorOptions } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState } from 'react';

type ColumnTextEditorProps = ColumnEditorOptions & {
  id: string;
  onFocus?: () => void;
  onBlur?: () => void;
  isPercentage?: boolean;
  blockPercentage?: boolean;
  allowOnlyPositive?: boolean;
};

const ColumnTextEditor = ({
  id,
  editorCallback,
  value,
  onFocus,
  isPercentage,
  blockPercentage,
  allowOnlyPositive,
  onBlur,
}: ColumnTextEditorProps) => {
  const [prevValue, setPrevValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value ?? '');
  const numberRegex = new RegExp(
    `^(${allowOnlyPositive ? '' : '-?'}(\\d*(\\.\\d{0,2})?))$`
  );
  const numberPercentageRegex = new RegExp(
    `^(${
      allowOnlyPositive ? '' : '-?'
    }(\\d+(\\.\\d{0,2})?|\\.\\d{0,2})?%?|-%|%)$`
  );

  const executeCallback = (text: string) => {
    try {
      if (editorCallback) {
        editorCallback(text);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 25);
  }, []);

  return (
    <React.Fragment>
      <InputText
        ref={inputRef}
        type="text"
        id={id}
        keyfilter={
          blockPercentage || isPercentage ? numberRegex : numberPercentageRegex
        }
        validateOnly={true}
        onFocus={onFocus}
        onInput={(event, validatePattern) => {
          const target = event.currentTarget;
          const hasLength = target.value.length > 0;

          if (validatePattern && hasLength) {
            setPrevValue(target.value);
            return;
          }

          if (hasLength) {
            target.value = prevValue;
          }
        }}
        className="w-full"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          executeCallback(e.target.value);
        }}
        onBlur={(e) => {
          executeCallback(e.target.value);
          if (onBlur) onBlur();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            executeCallback(inputValue);
          }
        }}
      />
      {!isPercentage && !blockPercentage && (
        <Tooltip
          target={`#${id}`}
          content={`Enter amount or percentage by using '%' at the end`}
          position="top"
          event="focus"
        />
      )}
    </React.Fragment>
  );
};

export default ColumnTextEditor;
